export default __webpack_public_path__ + "static/media/dogplaceholder.ffabae22.jpg";